export default {
  Navigation: {
    retract: '收起导航',
    opennav: '展开导航',
    app: '应用',
    workbench: '工作台',
    complete: '完成',
    commonly: '常用设置',
    myCommonly: '我的常用',
    appDragApp: '按住拖动排序，最多可添加8个',
    system: '系统模块',
    cApp: '机构应用',
    goAdd: '去添加',
    editPwd: '修改密码',
    determine: '确定',
    cancel: '取消',
    mail: '未读邮件',
    allRead: '全部标为已读',
    viewAll: '查看全部',
    notification: '消息通知',
    help: '帮助文档',
    suggest: '建议反馈',
    viode: '视频教程',
    guide: '新手引导',
    preferences: '偏好设置',
    personal: '个人设置',
    gobackend: '系统后台设置',
    exit: '退出',
    selectColor: '选择颜色',
    customColors: '自定义颜色',
    Tips: '提示',
    Dear: '尊敬的用户',
    Expire1: '使用时间即将到期，到期时间',
    Expire2: '请即时联系平台运维工作人员',
    repeatAddition: '自定义颜色重复添加',
    quickAdd: '快速新增',

    switchcompanies: '切换',
    myapp: '我的应用',
    createapplication: '创建应用',
    helpcenter: '帮助中心',
    mobileterminaluse: '移动端使用',
    helpdocument: '帮助文档',
    technicalsupport: '技术支持',
    applicationcenter: '应用中心',
    updatelog: '更新日志',
    requirementsfeedback: '需求反馈',
    productevaluation: '产品评价',
    turnonlevitationbutton: '开启悬浮按钮',
    layoutsettings: '布局设置',
    skinsettings: '皮肤设置',
    selectskin: '选择皮肤',
    custom: '自定义',
    selectskinTip: '建议使用1920*1024尺寸图片',
    teamfacegivesyoumoreoptions: '给你更多选择',
    youcanuseteamfaceonmobileinthefollowingway: '您可以通过以下几种方式在移动端使用',
    teamfacewechatservicenumber: '微信服务号',
    scancodetofollowTip: '扫码关注公众号在微信中使用系统',
    scancodetofollowTip2: '关注公众号登录系统',
    integrationintothirdpartyapp: '集成到第三方应用',
    applyfortrial: '申请试用',
    toconsultcustomerservice: '扫码咨询微信客服',
    callforinformation: '咨询电话',
    needanothermobilesolutio: '需要其他移动端方案？请点击告诉我们',
    renewalalert: '续费提醒',
    dearuseryourservicehasexpire:
      '尊敬的用户，您的服务已到期。如需继续使用请及时续费或来电咨询，续费后可正常使用。',
    totalsystemquantitytotalspace: '系统数量总量/空间总量',
    upto90: '已达90%',
    rechargeassoonaspossibleTip: '请尽快充值，避免因为数量不足导致业务数据无法新建保存成功',
    pay: '支付',
    yuandelayedbyoneday: '元延期一天',
    renewimmediatelyperyear: '立即续费（按年）',
    selectlayout: '选择布局',
    selectpopover: '选择弹窗',
    renewalperiod: '续费年限',
    platformmessages: '平台消息',
    upgradealert: '升级提醒',
    laterversion: '更新版本',
    updatecontent: '更新内容：',
    isee: '我知道了',
    sideshot: '侧弹',
    popover: '弹窗',
    fullscreenpopover: '全屏弹窗',
    classicnavigation: '经典导航式',
    simplenavigation: '简约导航式',
    traditionalnavigation: '传统导航式',
    traditionalfunctional: '传统职能式',
    sidebarnavigation: '侧栏导航式',
    sidebarfunctional: '侧栏职能式',
    customerexpirationdate: '客户使用时间到期',
    backofficemanagement: '后台管理',
    workbenchmanage: '门户管理',
    approvalmanage: '审批管理',
    projectmanage: '项目管理',
    emailmanage: '邮件管理',
    reportmanage: '数据报表',
    attendancemanage: '考勤管理',
    salarymanage: '薪酬管理',
    repositorymanage: '知识库管理',
    filelibrarymanage: '文件库管理',
    appmanage: '应用管理',
    num1: 'a111',
    selectcompanyindustry: '选择机构所在行业',
    industryofthecompany: '机构所属行业',
    selectsystemtouse: '选择使用系统',
    nextstep: '下一步',
    gotoappmarket: '前往应用市场',
    seemoreapps: '查看更多应用',
    backup: '上一步',
    nofindasuitableapplicatio: '没有找到合适的应用？快去',
    createmanually: '手动创建',
    bar: '吧~',
    clicktousetheapp: '点击进入使用应用',
    oneclicktoinstallanduseapps: '点击一键安装使用应用',
    totalrequirementsgathering: '全部需求收集',
    newdata: '新增数据',
    moreoperations: '更多操作',
    batchimportdata: '批量导入数据',
    step1: '1/3 模块列表头部操作',
    step2: '2/3 模块列表标题栏操作',
    step3: '3/3 添加子菜单操作',
    customerowner: '客户所有人',
    customername: '客户名称',
    totalnumber: '总人数',
    industry: '所属行业',
    checkthefieldsyouwanttodisplay: '勾选您要显示的字段',
    moveinandclickanddragcolumnwidth: '移入点击拖动列宽',
    administratorcansavedraggedcolumnwidth: '管理员可保存拖动的列宽',
    clickautosort: '点击自动排序',
    setlistdisplayfield: '设置列表显示字段',
    filterlistdata: '筛选列表数据',
    addsubmenu: '添加子菜单',
    addedsubmenu: '添加的子菜单',
    whaticareabout: '我关注的',
    addenterpriseapplications: '添加企业应用',
    enterpriseapplicationcenter: '企业应用中心',
    alltradesandoccupationsreadytouse: '各行各业即装即用',
    createblankapplication: '创建空白应用',
    buildwhateveryouwant: '随心所欲搭建',
    enterprisecustomization: '企业私有定制',
    professionalconsultantscustomised: '专业顾问个性化定制',
    underinstallation: '安装中…',
    customerrelationshipmanagement: '客户关系管理',
    hrhumanresourcesystem: 'HR人力资源系统',
    srmsupplierrelationshipmanagementsystem: 'SRM供应商关系管理系统',
    invoicingmanagement: '进销存管理',
    environmentalengineering: '环保工程',
    propertymanagementsystem: '物业管理系统',
    batchmodification: '批量修改',
    founder: '创建人',
    createtime: '创建时间',
    ordernumber: '订单号',
    department: '所属部门',
    belongingnumber: '所属编号',
    contractname: '合同名称',
    contractnumber: '合同编号',
    contractpartya: '合同甲方',
    personinchargeofpartya: '甲方负责人',
    companyindustry_empty: '机构所属行业不能为空',
    systemtouse_empty: '请选择使用系统',
    scan_download: '扫码下载',
    also: '还可以',
    appapply: '手机应用',
    complaintsSuggestions: '投诉建议',
    EnterpriseBackgroundSetting: '系统后台设置',
    AppNav: '应用导航',
    mouseDragSort: '按住鼠标不放，拖拽可调整顺序',
    noResultsReceived: '暂未收到相关结果',
    appSetting: '应用设置',
    portalSetting: '门户设置',
    KnowledgeSetting: '知识库设置',
    librarySetting: '文件库设置'
  }
}
